import { render, staticRenderFns } from "./OrientationWarning.vue?vue&type=template&id=2a2a6830"
import script from "./OrientationWarning.vue?vue&type=script&lang=js"
export * from "./OrientationWarning.vue?vue&type=script&lang=js"
import style0 from "./OrientationWarning.vue?vue&type=style&index=0&id=2a2a6830&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports